import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { Item } from 'src/app/models/item';

import { CartService } from '../../cart.service';
import { CartItem } from '../../cartItem';
import { CurrencyConverterService } from '../../../services/currency-converter.service';
import { Store } from '@ngrx/store';
import { CartState } from '../../state/cart.reducers';
import { CartProperties } from '../../state/cart.selectors';

import * as CartSelectors from '../../state/cart.selectors';
import * as CartActions from '../../state/cart.actions';

@Component({
  selector: 'app-cart-list',
  templateUrl: './cart-list.component.html',
  styleUrls: ['./cart-list.component.css'],
  changeDetection: ChangeDetectionStrategy.Default
})
export class CartListComponent implements OnInit {

  // activeCart$: Observable<Cart>;

  cartItems$: Observable<CartItem[]>;
  cartProperties$: Observable<CartProperties>;

  constructor(
    private cs: CartService, 
    private currSrv: CurrencyConverterService,
    private store: Store<CartState>
  ) { }


  ngOnInit(): void {
    // this.activeCart$ = this.cs.activeCart$;
    this.cartItems$ = this.store.select(CartSelectors.cartItems);
    this.cartProperties$ = this.store.select(CartSelectors.cartProps);


  }

  onAddToCart(item: Item) {
    
    try {
      // console.log('list lvl onAddToCart started');
      // this.cs.addToCart(cartItem);
      this.store.dispatch(CartActions.addToCart({item}));
      // this.cs.newCart(item);
      // console.log('list lvl  item added to cart');

    }
    catch (err) {
      console.log('error in service addToCart function: ', err);
    }

  }

  onAddOne(cartItem: CartItem) {

    try {
      console.log('list lvl onAddToCart started');
      // this.cs.addOne(index);
      this.store.dispatch(CartActions.addOne({cartItem}));
      // this.cs.newCart(item);
      console.log('list lvl  item added to cart');

    }
    catch (err) {
      console.log('error in service addToCart function: ', err);
    }

  }

  onRemoveOne(cartItem: CartItem) {

    try {
      console.log('list lvl onAddToCart started');
      // this.cs.removeOne(index);
      this.store.dispatch(CartActions.removeOne({cartItem}));
      // this.cs.newCart(item);
      console.log('list lvl  item added to cart');

    }
    catch (err) {
      console.log('error in service addToCart function: ', err);
    }

  }

  onRemoveRow(cartItem: CartItem) {

    try {
      console.log('list lvl removeAll started');
      // this.cs.removeRow(rowNr);
      this.store.dispatch(CartActions.removeLine({cartItem}));
      // this.cs.newCart(item);
      console.log('list lvl  row removed');

    }
    catch (err) {
      console.log('error in service addToCart function: ', err);
    }

  }

  onReturnRow(cartItem: CartItem) {
    try {
      console.log('list lvl removeAll started');
      // this.cs.returnRow(index);
      this.store.dispatch(CartActions.invertLine({cartItem}));
      // this.cs.newCart(item);
      console.log('list lvl  row removed');

    }
    catch (err) {
      console.log('error in service addToCart function: ', err);
    }
  }

}
